<template>
  <v-layout column >
    <!-- div class="white elevation-2" -->
      <v-toolbar flat dense class="indigo" dark>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <slot name="action">
          </slot>

      </v-toolbar>

      <div class="pl-1 pr-1 pt-0 pb-3 mb-4"  >
          <slot name="top">
              No slot content defined
          </slot>
      </div>
    <!-- /div -->
    <Toast/>
  </v-layout>
</template>

<script>
import Toast from "@/components/Toast" ;
export default {
  components: {
    Toast
  },
  props: [
    'title'
  ]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Panel.vue